import React from "react";
import { connect } from "react-redux";
import {
  loadHourUtilizationRequest,
  updateHourUtilizationRequest,
  cancelHourUtilizationRequest,
  acceptHourUtilizationRequest,
} from "../../../redux/actions/HourUtilizationRequestActions";
import { loadAvailableHours } from "../../../redux/actions/AvailableHoursActions";
import { loadUtilizationRequestStatuses, getBlackoutPeriodActive } from "../../../redux/actions/UtilityActions";
import { Form } from "react-bootstrap";
import FormRow from "../../common/forms/FormRow";
import ConsultantFNFilter from "../common/searchFilters/ConsultantFNFilter";
import ConsultantLNFilter from "../common/searchFilters/ConsultantLNFilter";
import RateFilter from "../common/searchFilters/RateFilter";
import UtilizationRequestStatusFilter from "../common/searchFilters/UtilizationRequestStatusFilter";
import AcceptRequestModal from "./AcceptRequestModal";
import EditRequestModal from "./EditRequestModal";
import CancelRequestModal from "./CancelRequestModal";
import EditPaidDateModal from "./EditPaidDateModal";
import DataGrid from "../../common/DataGrids/DataGrid";
import Page from "../../common/Page";
import BlackoutAlert from "../../common/alerts/BlackoutAlert";
import { addDatePaid } from "../../../apis/revshare/HourUtilizationApi";
import moment from "moment";

class UtilizationRequestPage extends React.Component {
  render() {
    return (
      <Page
        pageTitle="Requests"
        pageHeader={
          this.props.profile.isAdmin && !this.props.profile.ghost ? (
            <Form>
              <FormRow
                columns={[
                  <ConsultantFNFilter
                    onChange={this.filterResults}
                    names={[...new Set(this.props.hourUtilizationRequests.map((i) => i.consultantFirstName))]}
                    ref={(element) => (this.consultantFNFilter = element)}
                  />,
                  <ConsultantLNFilter
                    onChange={this.filterResults}
                    names={[...new Set(this.props.hourUtilizationRequests.map((i) => i.consultantLastName))]}
                    ref={(element) => (this.consultantLNFilter = element)}
                  />,
                  <RateFilter
                    onChange={this.filterResults}
                    rates={[...new Set(this.props.hourUtilizationRequests.map((i) => i.rate))]}
                    ref={(element) => (this.rateFilter = element)}
                  />,
                  <UtilizationRequestStatusFilter
                    onChange={this.filterResults}
                    statuses={this.props.statuses}
                    ref={(element) => (this.statusFilter = element)}
                  />,
                ]}
              />
            </Form>
          ) : null
        }
      >
        {this.props.blackedOut ? <BlackoutAlert /> : null}
        <DataGrid
          actionButtons={this.renderButtons}
          adminHeaders={this.state.adminHeaders}
          headers={this.state.headers}
          data={
            this.state.filtered
              ? this.state.filteredResults
              : this.props.hourUtilizationRequests.filter(
                  (row) => row.status !== "Cancelled" && row.status !== "Accepted"
                )
          }
          exportName="utilization_requests"
          isAdmin={this.props.profile.isAdmin}
          isGhosting={this.props.profile.ghost}
          tableModifiers={[
            <Form.Check
              id="show-canceled-toggle-switch"
              label="Show processed requests"
              onChange={this.onShowCanceledSwitchChange}
              ref={(element) => (this.showCanceledSwitch = element)}
              type="switch"
              value="dark"
            />,
          ]}
        />
      </Page>
    );
  }

  constructor(props) {
    super(props);
    this.state = {
      cashOutBlackedOut: false,
      filteredResults: this.props.hourUtilizationRequests.filter((row) => row.status !== "Cancelled"),
      filtered: false,
      ghost: null,
      adminHeaders: [{ label: "Name", key: "consultantName" }],
      headers: [
        { label: "Status", key: "status" },
        { label: "Hours", key: "hours" },
        { label: "Rate", key: "rate" },
        { label: "Type", key: "utilizationType" },
        { label: "Requested On", key: "dateCreated" },
        { label: "Acknowledged On", key: "dateAcknowledged" },
        { label: "Paid On", key: "datePaid" },
      ],
      resetShowCanceled: false,
    };

    this.renderButtons = this.renderButtons.bind(this);
    this.filterResults = this.filterResults.bind(this);
    this.onShowCanceledSwitchChange = this.onShowCanceledSwitchChange.bind(this);
  }

  componentDidMount() {
    this.props.loadAvailableHours(this.props.profile.isAdmin, this.props.profile.ghost).catch((error) => alert(error));
    this.props
      .loadHourUtilizationRequest(this.props.profile.isAdmin, this.props.profile.ghost)
      .catch((error) => alert(error));
    this.props.loadUtilizationRequestStatuses();
    this.setState({ ghost: this.props.profile.ghost });
    this.props.getBlackoutPeriodActive();
  }

  componentDidUpdate() {
    if (this.props.profile.ghost !== this.state.ghost) {
      this.props
        .loadAvailableHours(this.props.profile.isAdmin, this.props.profile.ghost)
        .catch((error) => alert(error));
      this.props
        .loadHourUtilizationRequest(this.props.profile.isAdmin, this.props.profile.ghost)
        .catch((error) => alert(error));
      this.setState({ ghost: this.props.profile.ghost });
    }
  }

  renderButtons(request) {
    if (this.props.blackedOut) {
      return null;
    } else {
      if (request.status === "Submitted") {
        return (
          <>
            {this.props.profile.isAdmin && !this.props.profile.ghost ? (
              <AcceptRequestModal request={request} accept={this.props.acceptHourUtilizationRequest} />
            ) : null}
            <EditRequestModal request={request} update={this.props.updateHourUtilizationRequest} />
            <CancelRequestModal recordId={request.id} cancel={this.props.cancelHourUtilizationRequest} />
          </>
        );
      } else {
        if (request.status === "Accepted") {
          return this.props.profile.isAdmin && !this.props.profile.ghost ? (
            <>
              <EditPaidDateModal
                key={`${request.id}`}
                request={request}
                edit={(paidDate) =>
                  addDatePaid(request.id, { PaidDate: moment(paidDate).format() }).then(() =>
                    this.props
                      .loadHourUtilizationRequest(this.props.profile.isAdmin, this.props.profile.ghost)
                      .catch((error) => alert(error))
                  )
                }
              />
            </>
          ) : null;
        } else {
          return null;
        }
      }
    }
  }

  filterResults() {
    let results = this.state.filteredResults;
    if (
      this.consultantFNFilter.value === "All" ||
      this.consultantLNFilter.value === "All" ||
      this.rateFilter.value === "All" ||
      this.statusFilter.value !== "All"
    ) {
      results = this.props.hourUtilizationRequests;
    }
    if (this.consultantFNFilter.value !== "All") {
      results = results.filter((row) => row.consultantFirstName === this.consultantFNFilter.value);
    }
    if (this.consultantLNFilter.value !== "All") {
      results = results.filter((row) => row.consultantLastName === this.consultantLNFilter.value);
    }
    if (this.rateFilter.value !== "All") {
      results = results.filter((row) => row.rate === this.rateFilter.value);
    }
    if (this.statusFilter.value !== "All") {
      if (
        (this.statusFilter.value === "Cancelled" || this.statusFilter.value === "Accepted") &&
        !this.showCanceledSwitch.checked
      ) {
        this.setState({ resetShowCanceled: true });
        this.showCanceledSwitch.checked = true;
      } else if (this.state.resetShowCanceled) {
        this.setState({ resetShowCanceled: false });
        this.showCanceledSwitch.checked = false;
      }
      results = results.filter((row) => row.status === this.statusFilter.value);
    }
    if (!this.showCanceledSwitch.checked) {
      results = results.filter((row) => row.status !== "Cancelled" || row.status !== "Accepted");
    }
    this.setState({ filteredResults: results, filtered: true });
  }

  onShowCanceledSwitchChange() {
    this.filterResults();
  }
}

function mapStateToProps(state, ownProps) {
  return {
    blackedOut: state.blackoutPeriod,
    hourUtilizationRequests:
      // check if available hours have loaded
      state.availableHours.length === 0 || state.hourUtilizationRequests.length === 0
        ? [] // if not don't assign a value yet
        : // If yes assigna value
          state.hourUtilizationRequests.map((request) => {
            // Search availible hours
            let availableHoursRecord = state.availableHours.find(
              // find records where the consultant and rate are the same as the request
              (hours) => hours.consultantId === request.consultant && hours.rateValue === request.rateValue
            );
            // Build the object to be stored in props.hourUtilizationRequests
            return {
              // Add all fields from the object in store
              ...request,
              // Also add the requestable hours calculated from available hours
              requestableHours: availableHoursRecord
                ? availableHoursRecord.hours - availableHoursRecord.pendingHours
                : 0.0,
            };
          }),
    profile: state.profile,
    statuses: state.utilizatioRequestStatus,
  };
}

const mapDispatchToProps = {
  getBlackoutPeriodActive,
  loadAvailableHours,
  loadHourUtilizationRequest,
  loadUtilizationRequestStatuses,
  updateHourUtilizationRequest,
  cancelHourUtilizationRequest,
  acceptHourUtilizationRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(UtilizationRequestPage);
